module.exports = __webpack_public_path__ + "static/media/CP_2022_03_TI212_mono_couche (1).30434ce2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/CP_2022_03_TI212_mono_couche (1).jpg
// module id = 1157
// module chunks = 0